export const STRIPE_TESTING_LINK = "https://stripe.com/docs/issuing/testing";
